import { NgClass, NgStyle } from "@angular/common";
import { Component, computed, input } from "@angular/core";

@Component({
  standalone: true,
  selector: "app-multi-image-preview",
  templateUrl: "./multi-image-preview.component.html",
  styleUrls: ["./multi-image-preview.component.scss"],
  imports: [NgClass, NgStyle],
})
export class MultiImagePreviewComponent {
  protected readonly images = input.required<string[]>();
  protected readonly totalImages = computed(() => this.images().length);
  protected readonly imagesToShow = computed(() => this.images().slice(0, 5));
  protected readonly numImages = computed(() => this.imagesToShow().length);

  public isSecondRow(index: number): boolean {
    const threeOrFourImagesCondition =
      (this.numImages() === 3 || this.numImages() === 4) && index > 0;
    const fiveImagesCondition = this.numImages() === 5 && index > 1;
    return threeOrFourImagesCondition || fiveImagesCondition;
  }

  public isTwoImagesRow(index: number): boolean {
    return (
      this.numImages() === 2 ||
      (this.numImages() === 3 && this.isSecondRow(index)) ||
      (this.numImages() === 5 && !this.isSecondRow(index))
    );
  }
}
